import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-overlay-loading',
    templateUrl: './overlay-loading.component.html',
    styleUrls: ['./overlay-loading.component.scss'],
    standalone: false
})
export class OverlayLoadingComponent implements OnInit {

  constructor() {
    // This is intentional
  }

  ngOnInit() {
    // This is intentional
  }

}
